import { Login } from "@lib/auth/client";
import { hasSessionCookie } from "@lib/auth/client/cookie";
import "microtip/microtip.css";
import { useEffect } from "react";
import Modal from "react-modal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, Switch } from "wouter";
import { OutOfDateVersionWarning } from "./components/utils/OutOfDateVersionWarning";
import { Home } from "./pages/home/Home";
import { ViewProposalPage } from "./pages/proposals/ViewProposalPage";
import { Round } from "./pages/round/Round";
import { ThemeProvider } from "./utils/useTheme";

export function App() {
  const hasSession = hasSessionCookie();

  useEffect(() => {
    try {
      Modal.setAppElement("#app");
    } catch {
      console.error("failed to set app element");
    }
  }, []);

  if (!hasSession) {
    return (
      <RootComponentAndTheme>
        <Login />
      </RootComponentAndTheme>
    );
  }

  return (
    <RootComponentAndTheme>
      <OutOfDateVersionWarning />
      <Root />
    </RootComponentAndTheme>
  );
}

function RootComponentAndTheme({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-stone-100 dark:bg-[#181818] text-stone-800 dark:text-stone-100">
      <ThemeProvider>
        <div id="app">
          <ToastContainer
            style={{ zIndex: 10_001 /* modal uses 10_000 */ }}
            stacked
          />
          {children}
        </div>
      </ThemeProvider>
    </div>
  );
}

function Root() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/round/:roundId" component={Round} nest />
      <Route
        path="/proposal/:roundId/:proposalId"
        component={ViewProposalPage}
      />
    </Switch>
  );
}
